import React from "react";
import propTypes from "prop-types";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import styled from "styled-components";
import Dropzone from "react-dropzone";

const StyledDropzone = styled(Dropzone)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 300px;
  min-height: 200px;
  border: 2px dashed;
  flex-flow: row wrap;
  transition: 0.3s color;

  p {
    width: 100%;
    text-align: center;
    margin: 0 0 auto;
  }

  svg {
    margin: auto auto 1em;
    display: block;
  }
  &:hover {   
    cursor:pointer; 
    color:#2196F3;
  }
`;

const Upload = ({ onDrop, multiple }) => (
  <StyledDropzone onDrop={onDrop} multiple={multiple}>
    <CloudUploadIcon />
    <p>Click or drop files to upload</p>
  </StyledDropzone>
);

Upload.propTypes = {
  onDrop: propTypes.func.isRequired,
  multiple: propTypes.bool
};

Upload.defaultProps = {
  multiple: true
};

export default Upload;
